package com.sddamico.draftmachine.components.widgets

import androidx.compose.runtime.Composable
import com.sddamico.draftmachine.data.OwnershipSyncStatus
import com.sddamico.draftmachine.ds.core.Badge
import com.sddamico.draftmachine.ds.core.BadgeTone

/** Sibling of [StatusBadge] for league ownership sync runs. */
@Composable
fun SyncStatusBadge(status: OwnershipSyncStatus?) {
  when (status) {
    OwnershipSyncStatus.RUNNING -> Badge("Syncing", tone = BadgeTone.Glass, dot = true)
    OwnershipSyncStatus.PENDING -> Badge("Queued", tone = BadgeTone.Patina, dot = true)
    OwnershipSyncStatus.SUCCEEDED -> Badge("Synced", tone = BadgeTone.Verde, dot = true)
    OwnershipSyncStatus.FAILED -> Badge("Failed", tone = BadgeTone.Rust)
    null -> Badge("Never synced", tone = BadgeTone.Neutral)
  }
}
